import React, { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { MultiToggleSwitch } from 'components/atoms';

import PATHS from 'routes/PATHS';

import './Header.scss';

type HeaderProps = {
  isAdmin: boolean;
};

const Header: FC<HeaderProps> = ({ isAdmin }) => {
  const navTabs = [
    { title: 'Message', link: PATHS.MESSAGE },
    { title: 'History', link: PATHS.HISTORY },
  ];

  if (isAdmin && !navTabs.find((item) => item.link === PATHS.TRANSLATIONS))
    navTabs.push({ title: 'Translations', link: PATHS.TRANSLATIONS });

  const location = useLocation();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(
    navTabs.findIndex((item) => item.link === location.pathname.replace('/', '')),
  );

  useEffect(() => {
    setActiveIndex(navTabs.findIndex((item) => item.link === location.pathname.replace('/', '')));
  }, [location]);

  useEffect(() => {
    setActiveIndex(navTabs.findIndex((item) => item.link === location.pathname.replace('/', '')));
  }, [isAdmin]);

  useEffect(() => {
    if (activeIndex === -1) setActiveIndex(0);
  }, [activeIndex]);

  return (
    <header>
      <h1 onClick={() => navigate(PATHS.ROOT)}>Message</h1>
      <MultiToggleSwitch
        activeIndex={activeIndex === -1 ? 0 : activeIndex}
        setActiveIndex={setActiveIndex}
        values={navTabs}
        size={0.9}
      />
    </header>
  );
};

export default Header;
